<template>
  <div class="ar4-details-tab py-4" :class="{ 'px-8': !breakpointXs, 'px-2': breakpointXs }">
    <div class="ar4-details-tab__table pt-2">
      <div
        class="ar4-details-tab__table__header d-sm-flex justify-space-between align-center"
        :class="{ 'text-center': breakpointXs }"
      >
        <v-text-field v-model="search" label="Search" single-line hide-details class="mw-25"></v-text-field>
        <v-btn color="button-primary" class="white--text" :class="{ 'mt-4': breakpointXs }" @click="addNewAr4">
          <span class="font-weight-bold">Add AR4 Details</span>
        </v-btn>
      </div>
      <div class="ar4-details-tab__table__body mt-5">
        <v-data-table :items-per-page="5" :headers="tableHeaders" :items="ar4s" :search="search">
          <template v-slot:item.edit="{ item }">
            <v-btn color="lightPrimary" class="info font-weight-bold mx-2" dense @click="updateActionHandler(item)"
              >Edit</v-btn
            >
          </template>
          <template v-slot:item.delete="{ item }">
            <v-btn color="lightPrimary" class=" error font-weight-bold" dense @click="deleteActionHandler(item)"
              >Delete</v-btn
            >
          </template>

        </v-data-table>
      </div>
    </div>
    <v-dialog v-model="dialog" max-width="1000" persistent>
      <v-card :class="{ 'pa-7': !breakpointXs, 'pa-2': breakpointXs }">
        <v-card-title class="justify-space-between">
          <div :class="{ 'fs-25': !breakpointXs, 'fs-20': breakpointXs, 'fw-600': true }">
            Add AR4 Details
          </div>
          <v-btn icon @click="dialog = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text :class="{ 'pt-5': !breakpointXs, 'pt-0': breakpointXs }">
          <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="ar4No"
                  rules="required|max:17"
                  type="number"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAR4DetailsTabFormLoading || savingExportJob"
                  label="AR4 Number"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <DateField
                  v-model="ar4Date"
                  required
                  :loading="isAR4DetailsTabFormLoading || savingExportJob"
                  :inputLabel="'AR4 Date'"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  v-model="commissionerate"
                  rules="required|max:20"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAR4DetailsTabFormLoading || savingExportJob"
                  label="Commissionerate"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <TextField
                  rules="required|max:20"
                  v-model="division"
                  type="number"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAR4DetailsTabFormLoading || savingExportJob"
                  label="Division"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <v-textarea
                  v-model="range"
                  filled
                  required
                  rows="2"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAR4DetailsTabFormLoading || savingExportJob"
                  label="Range"
                />
              </v-col>
              <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
                <v-textarea
                  v-model="remark"
                  filled
                  rows="2"
                  showIcons
                  :showOnlyErrorIcons="true"
                  :loading="isAR4DetailsTabFormLoading || savingExportJob"
                  label="Remark"
                />
              </v-col>
            </v-row>
            <v-card-actions class="justify-end d-block d-sm-flex">
              <v-btn
                color="button-primary"
                outlined
                :block="breakpointXs"
                large
                width="140"
                @click="cancelAr4ModalActionHandler"
              >
                <span class="font-weight-bold fs-15">Cancel</span>
              </v-btn>
              <v-btn
                width="140"
                color="button-primary"
                large
                :block="breakpointXs"
                :class="{ 'white--text': true, 'my-3': !breakpointXs, 'ml-0 mt-3': breakpointXs }"
                :loading="isAR4DetailsTabFormLoading || savingExportJob"
                @click="passes(saveAr4)"
              >
                <span class="font-weight-bold fs-15">Save</span>
              </v-btn>
            </v-card-actions>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
        <div class="d-sm-flex justify-start" :class="{ 'text-center': breakpointXs }">
          <v-btn width="140" color="info" large class="white--text" @click="$emit('change-tab', 4)">
            <v-icon class="font-weight-bold fs-15 mr-2">fa fa-arrow-circle-left</v-icon>
            <span class="font-weight-bold fs-15">Previous</span>
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
        <div class="d-sm-flex justify-end" :class="{ 'text-center': breakpointXs }">
          <v-btn width="140" color="button-primary" large class="white--text" @click="saveAR4Details">
            <span class="font-weight-bold fs-15">Save</span>
          </v-btn>
          <div class="ml-2 mr-2 my-1"></div>
          <v-btn width="140" color="info" large class="white--text" @click="$emit('change-tab', 3)">
            <span class="font-weight-bold fs-15">Next</span>
            <v-icon class="font-weight-bold fs-15 ml-2">fa fa-arrow-circle-right</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import DateField from "@/components/DateField";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import handleExportJobMixin from "@/modules/DashboardModule/modules/ImportExportModule/mixins/handleExportJobMixin";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "AR4DetailsTab",
  components: {
    ValidationObserver,
    TextField,
    DateField
  },
  data() {
    return {
      isAR4DetailsTabFormLoading: false,
      search: "",
      dialog: false
    };
  },
  props: {
    itemSrNo: {
      type: Number,
      default: 1
    },
    invoiceSrNo: {
      type: Number,
      default: 1
    }
  },

  beforeDestroy() {
    this.makeFieldsNull();
  },
  mixins: [commonMethodsMixin, handleExportJobMixin],
  methods: {
    updateActionHandler(ar4) {
      this.$store.commit(MT.SET_AR4_FROM_EXPORT_JOB, { ar4No: ar4.ar4No });
      this.dialog = true;
      return;
    },
    deleteActionHandler(ar4) {
      this.$store.commit(MT.REMOVE_AR4_FROM_EXPORT_JOB, { srNo: ar4.srNo });
      this.$store.commit(MT.REASSIGN_SRNO_TO_AR4S_IN_EXPORT_JOB, ar4.srNo);
      return;
    },
    cancelAr4ModalActionHandler() {
      this.dialog = false;
    },
    saveAR4Details() {
      this.saveExportJob();
    },
    addNewAr4() {
      this.makeFieldsNull();
      this.srNo = this.ar4s.length + 1;
      this.dialog = true;
      return;
    },
    saveAr4() {
      const ar4 = { ...this.$store.getters.ar4 };
      ar4.srNo = this.srNo;
      ar4.itemSrNo = this.itemSrNo;
      ar4.invoiceSrNo = this.invoiceSrNo;
      this.$store.commit(MT.SET_AR4_IN_EXPORT_JOB, { ar4: ar4, srNo: this.srNo });
      this.dialog = false;
      return;
    },
    makeFieldsNull() {
      this.search = null;
      this.ar4No = null;
      this.ar4Date = "";
      this.commissionerate = null;
      this.division = null;
      this.range = null;
      this.remark = null;
      return;
    }
  },

  computed: {
    tableHeaders() {
      return [
        { text: "Sr No", value: "srNo", align: "center" },
        { text: "AR4 No", value: "ar4No", align: "center" },
        { text: "AR4 Date", value: "ar4Date", align: "center" },
        { text: "Commissionerate", value: "commissionerate", align: "center" },
        { text: "Division", value: "division", align: "center" },
        { text: "Range", value: "range", align: "center" },
        { text: "Remark", value: "remarks", align: "center" },
        { text: "Edit", value: "edit", align: "center" },
        { text: "Delete", value: "delete", align: "center" }
      ];
    },
    ar4s() {
      return this.$store.getters.exportJob.ar4s.filter(ar4 => {
        if (ar4.itemSrNo === this.itemSrNo && ar4.invoiceSrNo === this.invoiceSrNo) {
          return ar4;
        }
        return null;
      });
    },
    ar4No: {
      get() {
        return this.$store.state.ExportModuleStore.ar4.ar4No;
      },
      set(value) {
        this.$store.commit(MT.SET_AR4_AR4_NO, { value });
      }
    },
    ar4Date: {
      get() {
        return this.$store.state.ExportModuleStore.ar4.ar4Date;
      },
      set(value) {
        this.$store.commit(MT.SET_AR4_AR4_DATE, { value });
      }
    },
    commissionerate: {
      get() {
        return this.$store.state.ExportModuleStore.ar4.commissionerate;
      },
      set(value) {
        this.$store.commit(MT.SET_AR4_COMMISSIONERATE, { value });
      }
    },
    division: {
      get() {
        return this.$store.state.ExportModuleStore.ar4.division;
      },
      set(value) {
        this.$store.commit(MT.SET_AR4_DIVISION, { value });
      }
    },
    range: {
      get() {
        return this.$store.state.ExportModuleStore.ar4.range;
      },
      set(value) {
        this.$store.commit(MT.SET_AR4_RANGE, { value });
      }
    },
    remark: {
      get() {
        return this.$store.state.ExportModuleStore.ar4.remarks;
      },
      set(value) {
        this.$store.commit(MT.SET_AR4_REMARKS, { value });
      }
    }
  }
};
</script>
<style lang="scss">
.ar4-details-tab {
  min-height: 350px;
  &__table {
    .v-data-table {
      background: transparent !important;
    }
  }
}
</style>
